<template>
	<div class="col-md-6 offset-md-3 col-sm-12 h-100 p-3">
		<Loader v-if="loadingAcesso" />
		<Recaptcha v-else-if="!verificaAcessoValido" />

		<ErroCarregar v-else-if="erro !== false" />

		<Expirado v-else-if="expirado" />

		<Loader v-else-if="!carregando && !exibirAtendimento" />
		<div v-else-if="verificaExibirAtendimento">
			<router-view />
		</div>
	</div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAtendimentoStore } from '@/stores/atendimento';
import { useAcessoValidoStore } from '@/stores/acessoValido';
import { isEmpty, notifyDesktop, uniqueID } from '@/helper/funcoes';
import { toast } from '@/helper/alerts';
import { storeToRefs } from 'pinia';

import Recaptcha from "@/components/Recaptcha.vue";
import ErroCarregar from "@/components/ErroCarregar.vue";
import Loader from "@/components/Loadings/Loader.vue";
import Expirado from "@/components/Expirado.vue";

import { iniciarSocket } from '@/plugins/socket';

const route = useRoute();
const router = useRouter();

const store = useAtendimentoStore();
const { carregando, erro, expirado } = storeToRefs(store);

const loadingAcesso = ref(true);
const storeAcessoValido = useAcessoValidoStore();
const { acessoValido } = storeToRefs(storeAcessoValido);

let exibirAtendimento = ref(false);
let socket = null;

const verificaAcessoValido = computed(() => acessoValido.value);
const verificaExibirAtendimento = computed(() => exibirAtendimento.value);

async function carregarAtendimento(idAtendimento, atualizar = false) {
	try {
		await store.buscarDadosAtendimento({ idAtendimento, atualizar });		
		exibirAtendimento.value = !carregando.value && !erro.value && !expirado.value;

		if (atualizar) {
			if (navigator.userAgent.toLowerCase().indexOf("iphone") <= -1) {
				const notificacao = await notifyDesktop({
					body: 'Houve uma atualização no atendimento.',
					title: "Link solicitante",                
					vibrate: [200, 100, 200, 100, 200, 100, 200],
					tag: `atualizarAtendimento#${idAtendimento}_${uniqueID()}`,
					icon:  require("@/assets/img/link_solicitante.png"),
					badge:  require("@/assets/img/link_solicitante.png")
				});
				
				if (notificacao) {
					notificacao.onclick = function () {
						window.focus();
					};
				}
			} else {
				toast("info", "Houve uma atualização no atendimento.");
			}
		}
	} catch (error) {
		console.error("Falha ao carregar atendimento:", error);
	}
}

function conectarSocket(idAtendimento) {
	socket = iniciarSocket(idAtendimento);
	socket.on('connect', () => console.info('Socket conectado'));
	socket.on('disconnect', () => console.info('Socket desconectado'));
	socket.on('atualizarAtendimento', () => carregarAtendimento(idAtendimento, true));
	socket.connect();
}

function iniciarLink() {
	const id = route.params.idAtendimento;

	if (isEmpty(id) && !isEmpty(localStorage['ultimoAtendimentoAcessado'])) {
		router.replace({ path: `/${localStorage['ultimoAtendimentoAcessado']}` });
	}

	if (!isEmpty(id)) {
		localStorage['ultimoAtendimentoAcessado'] = id;
		carregarAtendimento(id, false);
	}

	socket.io.opts.query.idAtendimento = id;
	socket.connect();
}

function montaScriptGoogleKey() {
	const googleKey = process.env.NODE_ENV == 'development'
		? process.env.VUE_APP_GOOGLE_MAPS_KEY_DEV
		: process.env.VUE_APP_GOOGLE_MAPS_KEY;

	const sourceMapsApi = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&callback=Function.prototype`;
	const tag = document.querySelector(`script[src="${sourceMapsApi}"]`);
	if (!tag) {
		const script = document.createElement('script');
		script.src = sourceMapsApi;
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	}
}

watch(
	() => route.params.idAtendimento,
	(novoId) => {
		if (!novoId) return;

		conectarSocket(novoId);
		const valido = storeAcessoValido.verificaLocalStorage(novoId);
		montaScriptGoogleKey();

		if (valido) {
			iniciarLink();
		}

		loadingAcesso.value = false;
	},
	{ immediate: true } // roda de cara, se já tiver valor
);

watch(acessoValido, (novoValor) => {
	if (novoValor) {
		iniciarLink();
	}
});

onBeforeUnmount(() => {
	if (socket) socket.disconnect();
});

</script>
